// extracted by mini-css-extract-plugin
export default {"specItem":"spec-item_specItem__QuNpj","value":"spec-item_value__aWaq3","label":"spec-item_label__uHxaK"};